module.exports = __webpack_public_path__ + "img/icon-vk.004ec7c6.svg";